module.exports = __webpack_public_path__ + "img/im_hero_bg.1ead764e.png";